import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { deletetag } from "../../../../../utils/CommonFunc";
import { IMAGE_DNS } from "../../../../../utils/config/Config";
import { CommentData } from "../../../../../api/api";
import { userInfoState } from "../../../../../atoms/atom";
import { useRecoilValue } from "recoil";

interface IProps {
  data: CommentData;
  type: string;
  handleArticleEditor: (user_id: string, idx: number) => void;
  editingToggle: any;
  setEditingToggle: ({}) => void;
  isMyArticle: boolean;
  editBoard: (idx: number) => void;
  deleteBoard: (board_idx: number, comment_idx: number) => void;
  openRereply: (idx: number) => void | undefined;
}

function ReplyFrame(props: IProps) {
  const {
    data,
    type,
    handleArticleEditor,
    editingToggle,
    setEditingToggle,
    isMyArticle,
    editBoard,
    deleteBoard,
    openRereply
    // time
  } = props;
  const { t } = useTranslation();
  const userInfo = useRecoilValue(userInfoState);

  const compareUserId = (writerUser: string) => {
    if (
      writerUser.toLocaleLowerCase() === userInfo.Userid.toLocaleLowerCase()
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className={`${type === "re-reply" ? "re-reply" : ""} info clearfix`}>
      <img
        className="user-pic"
        src={
          data.admin_flag === 1
            ? data.admin_icon
            : IMAGE_DNS +
              "/Valofe_file/web/vfun-ko/images/common/img-user-default-min.png"
        }
        alt="profile-default"
      />
      <div className="info-writing f-right">
        <span className="nickname">
          {data.user_id}
          {compareUserId(data.user_id) ? (
            <Link
              to="#"
              className="btns icon-dots"
              onClick={(e) => handleArticleEditor(data.user_id, data.idx)}
            />
          ) : null}
        </span>

        {editingToggle[data.idx] ? (
          <ul
            className="btns editing"
            onMouseLeave={() => setEditingToggle({})}
          >
            {isMyArticle ? (
              <>
                <li className="edit">
                  <Link to="#" onClick={() => editBoard(data.idx)}>
                    <span className="icon edit" />
                    {t("edit")}
                  </Link>
                </li>
                <li className="delete">
                  <Link
                    to="#"
                    onClick={() => deleteBoard(data.board_idx, data.idx)}
                  >
                    <span className="icon delete" />
                    {t("delete")}
                  </Link>
                </li>
              </>
            ) : // <li className="report">
            //   <Link to="#">
            //     <span className="icon warning" />
            //     {t("report")}
            //   </Link>
            // </li>
            null}
          </ul>
        ) : null}

        <br />
        <div
          className="txt"
          dangerouslySetInnerHTML={{
            __html: deletetag(data.comment, ["img", "br"]) as string
          }}
        />
      </div>

      <ul className="info-writing f-right re-reply-activity clearfix">
        {/* 이미지 */}
        {data.images !== null && data.images.length !== 0 ? (
          <div style={{ width: "100%", paddingTop: "6px" }}>
            <img src={data.images} className="re-reply-img" />
          </div>
        ) : null}
        {type === "reply" && (
          <li className="re-reply-btn">
            <Link to="#" onClick={() => openRereply(data.idx)}>
              {t("write_a_comment")}
            </Link>
          </li>
        )}
        <li className="time">{data.created_at}</li>
      </ul>
    </div>
  );
}

export default ReplyFrame;
